import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, useInView } from 'framer-motion'
import Button from '../common/Button.jsx'
import Cards from '../common/Cards.jsx'
import './WhoWeAre.scss'

// Marquee Icons
import logo1 from '../../assets/Images/who-we-are/logo-1.svg'
import logo2 from '../../assets/Images/who-we-are/logo-2.svg'
import logo3 from '../../assets/Images/who-we-are/logo-3.svg'
import logo4 from '../../assets/Images/who-we-are/logo-4.svg'
import logo5 from '../../assets/Images/who-we-are/logo-5.svg'
import logo6 from '../../assets/Images/who-we-are/logo-6.svg'
import checkIcon from '../../assets/Images/who-we-are/check.svg'

// Data
const MARQUEE_ITEMS = [
    { icon: logo1, text: "SHELLS", alt: "SHELLS" },
    { icon: logo2, text: "SmartFinder", alt: "SmartFinder" },
    { icon: logo3, text: "Zoomerr", alt: "Zoomerr" },
    { icon: logo4, text: "ArtVenue", alt: "ArtVenue" },
    { icon: logo5, text: "kontrastr", alt: "kontrastr" },
    { icon: logo6, text: "WAVES", alt: "WAVES" }, 
]

const CHECKLIST_ITEMS = [
    "Create new digital products",
    "Modernize legacy systems",
    "Implement scalable, secure transformations",
    "Turn ideas into market-ready solutions"
]

export default function WhoWeAre() {
    const ref = useRef(null)
    const isInView = useInView(ref, { once: true, margin: "-100px" })
    const navigate = useNavigate()

    // We create a flattened array of 4 duplicates to ensure we fill large screens
    // and have enough buffer for a smooth loop.
    const marqueeContent = [
        ...MARQUEE_ITEMS,
        ...MARQUEE_ITEMS,
        ...MARQUEE_ITEMS,
        ...MARQUEE_ITEMS
    ];

    return (
        <section className="who-we-are-section" ref={ref}>

             {/* Marquee Section */}
            <div className="marquee-container">
                <p className="marquee-label">Trusted by Global Leaders Across Industries</p>

                <div className="marquee-wrapper">
                     <motion.div 
                        className="marquee-track"
                        animate={{ x: "-25%" }}
                        transition={{ 
                            repeat: Infinity, 
                            ease: "linear", 
                            duration: 40, // Adjust speed here (seconds)
                        }}
                     >
                        {marqueeContent.map((item, index) => (
                            <div key={`marquee-${index}`} className="marquee-item">
                                <div className="marquee-icon-wrapper">
                                    <img 
                                        src={item.icon} 
                                        alt={item.alt} 
                                        className="marquee-icon"
                                    />
                                </div>
                                <span className="marquee-text">{item.text}</span>
                            </div>
                        ))}
                     </motion.div>
                </div>
                {/* Fade Gradients */}
                <div className="marquee-fade-left"></div>
                <div className="marquee-fade-right"></div>
            </div>


            {/* Main Content Two-Column */}
            <div className="container-custom content-wrapper">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Left Column */}
                    <motion.div 
                        className="left-column"
                        initial={{ opacity: 0, x: -50 }}
                        animate={isInView ? { opacity: 1, x: 0 } : {}}
                        transition={{ duration: 0.8 }}
                    >
                        <div className="label-box">WHO WE ARE</div>
                        <h2 className="section-heading">
                            We Don’t Just Deliver Services. We Build What Powers Businesses.
                        </h2>
                        <p className="section-description">
                            Logiqlink is a technology consulting and engineering company focused on building intelligent platforms, embedded systems, and digital ecosystems for enterprises operating in high-impact environments.
                        </p>
                        <Button variant="outline" className="learn-more-btn" onClick={() => navigate('/about')}>
                            Learn More About Us
                        </Button>
                    </motion.div>

                    {/* Right Column (Card) */}
                    <motion.div 
                        className="right-column"
                        initial={{ opacity: 0, x: 50 }}
                        animate={isInView ? { opacity: 1, x: 0 } : {}}
                        transition={{ duration: 0.8, delay: 0.2 }}
                    >
                        <div className="info-card">
                            <h3>We partner with forward-thinking companies to:</h3>
                            <ul className="checklist">
                                {CHECKLIST_ITEMS.map((item, idx) => (
                                    <li key={idx} className="checklist-item">
                                        <img src={checkIcon} alt="Check" />
                                        <span>{item}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </motion.div>
                </div>
            </div>

             {/* Cards Component Integration */}
             <div className="cards-wrapper">
                 <div className="text-center mb-12">
                     <h2 className="cards-heading">
                         Architecting Digital Excellence for <br />
                         200+ Industry Leaders
                     </h2>
                 </div>
                 <Cards />
             </div>
        </section>
    )
}